module.exports = __webpack_public_path__ + "media/images/app/homepage/categories/earrings-cf3cddb8b5ecc45273af7fd78c3ece8e.webp";